/**
 * 入口js
 *
 */

import { initGlobalAPI } from './global-api';

import * as utils from './util';

let DDBridgeBeatles = {};

/* eslint-disable no-undef */
DDBridgeBeatles.Version = '1.0.4';

initGlobalAPI(DDBridgeBeatles);

DDBridgeBeatles.utils = utils;

export { DDBridgeBeatles };



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/index.js